import React from 'react';
import Demo from './demo/demo';

const Dashboard = () => (
  <React.Fragment>
    <Demo />
  </React.Fragment>
);

export default Dashboard;
